import QRCode from "@cdglib/js-qr-code";
import image from "@/image/image.js";
import building from "@/image/building.js";
import store from "@/stores/store";
import general from "@/js/general.js";
import myFunc from "../js/myFunction";

function formatId(id) {
  let docId = id.toString();
  if (docId.search(" ") != -1) {
  } else {
    let textId1 = docId.substring(0, docId.length - 4);
    let textId2 = Number(docId.substring(docId.length - 4));
    docId = textId1 + "/" + textId2;
  }
  return docId;
}
function formatNumberToThai(stringData) {
  var chars = {
    "0": "๐",
    "1": "๑",
    "2": "๒",
    "3": "๓",
    "4": "๔",
    "5": "๕",
    "6": "๖",
    "7": "๗",
    "8": "๘",
    "9": "๙"
  };
  var str = stringData.toString().replace(/[1234567890]/g, m => chars[m]);
  return str;
}
function formatDateToThaiString(date) {
  if (date) {
    let data = date.toString().padEnd(8, "0");
    let [year, month, day] = [
      data.substring(0, 4),
      data.substring(4, 6),
      data.substring(6, 8)
    ];
    if (day.charAt(0) == "0") {
      day = day.substring(1, 2);
    }
    if (day == "0") {
      day = "-";
    }
    if (month == "00") {
      month = "-";
    } else if (month == "01") {
      month = "มกราคม";
    } else if (month == "02") {
      month = "กุมภาพันธ์";
    } else if (month == "03") {
      month = "มีนาคม";
    } else if (month == "04") {
      month = "เมษายน";
    } else if (month == "05") {
      month = "พฤษภาคม";
    } else if (month == "06") {
      month = "มิถุนายน";
    } else if (month == "07") {
      month = "กรกฎาคม";
    } else if (month == "08") {
      month = "สิงหาคม";
    } else if (month == "09") {
      month = "กันยายน";
    } else if (month == "10") {
      month = "ตุลาคม";
    } else if (month == "11") {
      month = "พฤศจิกายน";
    } else if (month == "12") {
      month = "ธันวาคม";
    }
    return day + " " + month + " " + year;
  }
}
function formatPlaceDesc(placeDesc) {
  if (placeDesc.toString().substring(0, 8) == "ท้องถิ่น") {
    placeDesc = placeDesc.substring(8);
  }
  return placeDesc;
}
function formatDay(date) {
  if (date) {
    let data = date.toString().padEnd(8, "0");
    let day = data.substring(6, 8);
    if (day.charAt(0) == "0") {
      day = day.substring(1, 2);
    }
    return day;
  }
}
function formatMonth(date) {
  if (date) {
    let data = date.toString().padEnd(8, "0");
    let month = data.substring(4, 6);
    if (month == "01") {
      month = "มกราคม";
    } else if (month == "02") {
      month = "กุมภาพันธ์";
    } else if (month == "03") {
      month = "มีนาคม";
    } else if (month == "04") {
      month = "เมษายน";
    } else if (month == "05") {
      month = "พฤษภาคม";
    } else if (month == "06") {
      month = "มิถุนายน";
    } else if (month == "07") {
      month = "กรกฎาคม";
    } else if (month == "08") {
      month = "สิงหาคม";
    } else if (month == "09") {
      month = "กันยายน";
    } else if (month == "10") {
      month = "ตุลาคม";
    } else if (month == "11") {
      month = "พฤศจิกายน";
    } else if (month == "12") {
      month = "ธันวาคม";
    }
    return month;
  }
}
function formatYear(date) {
  if (date) {
    let data = date.toString().padEnd(8, "0");
    let year = data.substring(0, 4);
    return year;
  }
}
function getFullName(person) {
  let title = general.getTitleSex(
    person.titleDescription,
    person.titleSex,
    person.gender
  );
  var fullname = "";
  fullname = title.titleDesc1 + person.firstName;
  if (person.middleName != "") {
    fullname += " " + person.middleName;
  }
  fullname += " " + person.lastName;
  if (title.titleDesc2 != "") {
    fullname += " " + title.titleDesc2;
  }
  return fullname;
}

// การแปลงค่าที่จะปริ้นต่างๆ สามารถเรียกใช้ฟังก์ชั่นข้างบนได้
async function testPrint() {
  var document = {};
  document.place = 1301;
  document.id = 2;
  document.year = 2562;
  document.pid = 111111111111;
  // gen QR code
  let StringGenQRcode = "";
  let config = {
    level: "L",
    size: 500,
    padding: 4
  };
  let base64_QRCode_image = "";

  var docDefinition = {
    pageSize: "A4",
    // การใช้ฟังกฺชัน header แสดงทุกหน้า โดยความสูงจะไม่เกิน 60px
    header(currentPage, pageCount, pageSize) {
      // กำหนดค่าของ QRcode ของแต่ละโปรแกรม (ในตัวอย่างเป็นของ ทะเบียนชือ ช.1)
      StringGenQRcode =
        "03020100_" +
        document.place +
        "_" +
        document.id +
        "_" +
        document.year +
        "_" +
        document.pid +
        "_" +
        pageCount +
        "_" +
        currentPage;
        // แปลงค่าเป็น QRcode
      base64_QRCode_image = QRCode.encode(StringGenQRcode, config);
      
      // กำหนดเลขหน้าเป็นเลขไทย
      let pageHeader = "";
      pageHeader = formatNumberToThai("- " + currentPage + " -");
      return [
        {
          stack: [
            // วาง QRcode
            {
              width: 47,
              hight: 47,
              image: base64_QRCode_image,
              absolutePosition: { x: 485, y: 15 }
            },
            // วางเลขหน้าไว้ตรงกลาง
            {
              text: pageHeader,
              style: "normal",
              alignment: "center",
              bold: false
            }
          ]
        }
      ];
    },
    content: [
      // การปรับ margin [ ซ้าย, บน, ขวา, ล่าง ]
      // ข้อความอิงตามขอบกระดาษที่กำหนด

      // วางข้อความแบบ fixed ตำแหน่งของกระดาษ อิงตามแกน x,y (แนะนำให้วางไว้บนสุด ไม่งั้น position จะเพี้ยน)
      {
        text: "fixedfixedfixedfixedfixed",
        style: "normal",
        absolutePosition: { x: 100, y: 50 },
        bold: false
      },

      // วางข้อความไว้ตรงกลาง
      {
        text: "หัวข้อ",
        style: "big",
        alignment: "center",
        margin: [0, 4, 0, 0],
        bold: true
      },
      // วางข้อความปกติ บรรทัด 1
      {
        text: "ข้อความข้อความข้อความข้อความ1111",
        style: "normal",
        margin: [0, 4, 0, 0],
        bold: false
      },
      // วางข้อความปกติ บรรทัด 2
      {
        text: "ข้อความข้อความข้อความข้อความ2222",
        style: "normal",
        margin: [0, 4, 0, 0],
        bold: false
      },
      // วางข้อความปกติ บรรทัด 3
      {
        text: "ข้อความข้อความข้อความข้อความ3333",
        style: "normal",
        margin: [0, 4, 0, 0],
        bold: false
      },

       // วางข้อความซ้อนบรรทัดใช้ relativePosition อิงตามแกน x,y ปรับช่องไฟตามความเหมาะสม
       {
        text: "ทดสอบทดสอบทดสอบทดสอบทดสอบ",
        style: "normal",
        relativePosition: { x: 100, y: 0 },
        bold: false
      },
       {
        text: "............................................................................................",
        style: "normal",
        margin: [0, 4, 0, 0],
        bold: false
      },
      // แปลงวันที่
      {
        text: formatDateToThaiString(25620308),
        style: "normal",
        relativePosition: { x: 100, y: 0 },
        bold: false
      },
       {
        text: "............................................................................................",
        style: "normal",
        margin: [0, 4, 0, 0],
        bold: false
      },
      
    ],
    styles: {
      big: { fontSize: 18 },
      normal: { fontSize: 14 },
      small: { fontSize: 12 },
      header: {
        fontSize: 20,
        bold: true,
        alignment: "center"
        //   margin: [0, 10, 0, 0]
      },
      footer: { fontSize: 16, alignment: "left", margin: [60, 0, 0, 0] },
      tableBody: { fontSize: 14 },
      headerTable: {
        alignment: "center",
        bold: true,
        fontSize: "14",
        margin: [200, 20, 0, 10]
      },
      bodyTable: { alignment: "center" }
    },
    images: {
      building: building.image,
      check: image.check,
      clear: image.clear
    }
  };

  return docDefinition;
}

export default {
  testPrint,
  data() {
    return {};
  }
};
